export const SET_TESTIMONIALS = 'SET_TESTIMONIALS';
export const SET_AGENT = 'SET_AGENT';
export const SET_AGENT_ID = 'SET_AGENT_ID';
